const quantity = require('./woocommerce/quantity');
const checkout = require('./woocommerce/checkout');
const gallery = require('./woocommerce/gallery');
const login = require('./woocommerce/login');
const categoryWidget = require('./woocommerce/categorywidget');
